import React from 'react';

import { PopOverMenu, PopOverMenuButton } from 'components/ui/pop-over-menu'
import { Description, Title, listItemBaseStyles } from 'components/ui/list-item-label'

import { VisitorType } from 'generated/mos/org/getty/audio'

import { space } from 'helpers/style'
import {  IconWarning } from 'components/ui/icons'

import { visitorTypeSchema } from '../../schemas/visitor-type'


import styled from 'styled'

const Warning = styled.div`
  width: 20px;
`

const IconBlock = styled.div`
  display: flex;
  align-items: center;
  margin: 0 10px;
  font-weight: ${({ theme }) => theme.font.weight.base};
  color: ${({ theme }) => theme.color.grayL40};
`;


const IconsContainer = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 0;
`


export const Container = styled.div`
  border-radius: 0 0 ${space(1)} ${space(1)};
  padding-bottom: ${space(3)};
`

export const Content = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  overflow: hidden;
`

export const Wrap = styled.div`
  ${listItemBaseStyles}

  border-radius: ${space(1)};
  padding: ${space(3)};
  margin-bottom: 0;

  ${({ theme }) => `
    background-color: ${theme.color.white};
    border: ${`1px solid ${theme.color.grayL90}`};
    cursor: pointer;
  `}

  &:hover {
    border: ${({ theme }) => `1px solid ${theme.color.grayL90}`};
  }
`


type Props = {
  readonly historyPush: (id: string) => void;
  readonly projectId: string;
  readonly visitorType: VisitorType.Entity;
  readonly hasWarning?: boolean;
};

export const ListItem: React.FC<Props> = ({
  historyPush,
  projectId,
  visitorType,
  hasWarning,
}) => {
  const visitorTypeId = VisitorType.mustRef(visitorType.ref).id
  const editVisitorTypeLocation = `/project/${projectId}/visitor-type/${visitorTypeId}`


  const tag = visitorType && visitorType.tag && visitorTypeSchema.tag ? visitorTypeSchema.tag.read(visitorType.tag) as string : ''

  return(
    <Container onClick={() => historyPush(editVisitorTypeLocation)}>
      <Wrap>
        <Content>
          <Description>
            <Title>{tag}</Title>
          </Description>
        </Content>
        <IconsContainer>
          <IconBlock>
            <Warning>{hasWarning && <IconWarning size="small" color="warning" />}</Warning>
          </IconBlock>
        </IconsContainer>
        <PopOverMenu iconSize="base">
          <PopOverMenuButton
            onClick={(event) => {
              historyPush(editVisitorTypeLocation)
              event.stopPropagation()
            }}
          >
            Edit Visitor Type
          </PopOverMenuButton>
        </PopOverMenu>
      </Wrap>
    </Container>
  )
}
